module.exports = __webpack_public_path__ + "img/Principal.25e701df.jpg";